import { useContext } from 'react';
import { ChangeCompanyContext } from '../contexts/ChangeCompany';

export function useChangeCompany() {
    const context = useContext(ChangeCompanyContext);

    return context;
}
